import { render } from "./FooterBottom.vue?vue&type=template&id=789e8667&scoped=true"
import script from "./FooterBottom.vue?vue&type=script&lang=js"
export * from "./FooterBottom.vue?vue&type=script&lang=js"

import "./FooterBottom.vue?vue&type=style&index=0&id=789e8667&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789e8667"]])

export default __exports__